import { render, staticRenderFns } from "./OccurrenceSelect.vue?vue&type=template&id=636f9b97"
import script from "./OccurrenceSelect.ts?vue&type=script&lang=ts&external"
export * from "./OccurrenceSelect.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports